import { cn } from "@/lib/utils"

export type IconWrapper = {
  className?: string
  children: React.ReactNode
  ref?: React.Ref<HTMLDivElement>
}

export function IconWrapper({ className, children, ref }: IconWrapper) {
  return (
    <div ref={ref} className={cn("w-fit rounded-full p-1.5 text-[32px]", className)}>
      {children}
    </div>
  )
}
